<style>
    .counters {
        text-align: right;
    }
</style>

<template>
    <div class="counters">
        <v-chip color="green" text-color="white">
            <v-avatar class="green darken-4"><v-icon>account_circle</v-icon></v-avatar>
        <b>{{ this.teachers }}</b> &nbsp;  Teachers
        </v-chip>
        <v-chip color="green" text-color="white">
            <v-avatar class="green darken-4"><v-icon>assignment_ind</v-icon></v-avatar>
            <b>{{ this.students }}</b> &nbsp;  Students
        </v-chip>
        <v-chip color="green" text-color="white">
            <v-avatar class="green darken-4"><v-icon>people</v-icon></v-avatar>
            <b>{{ this.classes }}</b> &nbsp;  Classes
        </v-chip>
    </div>
  
</template>

<script>

import { getTeachersCount, getStudentsCount, getClassesCount, initialize} from '../utils/effort-tracking-api';
import { globalStore } from '../main.js'

export default {
    data () {
        return {
            name: 'counters',
            teachers: 0,
            students: 0,
            classes: 0
        }
    },
    methods:{
        updateCounters(){
            initialize().then(x => {
                //var periodId = globalStore.selectedPeriod;
                var periodId = localStorage.getItem('period-selected');
                getTeachersCount(periodId)
                .then(tc => this.teachers = tc)
                .catch(ex => console.log(ex));

                getStudentsCount(periodId)
                    .then(sc => this.students = sc)
                    .catch(ex => console.log(ex));

                getClassesCount(periodId)
                    .then(cc => this.classes = cc)
                    .catch(ex => console.log(ex));
            });
        }
    },
    mounted() {
        this.updateCounters();
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Counters.vue